import { useCallback, useState } from 'react';
import { useNotification } from '@refinedev/core';
import { httpClient, ROOT_URL } from '../../App';
import { getErrorMessage } from '../../api/error';

interface IUpdateBank {
  id?: number | null;
  name: string;
  tin?: string | null;
  intermediaryBank?: string | null;
  intermediarySwift?: string | null;
  intermediaryAddress?: string | null;
  swift: string;
  legalAddress: string;
  phoneNumber1?: string | null;
  phoneNumber2?: string | null;
  country?: string | null;
  userId?: number | null;
}

export const useUpdateBank = (id: number | undefined) => {
  const [isLoading, setIsLoading] = useState(false);
  const { open: openNotification } = useNotification();

  const update = useCallback(
    async (data: IUpdateBank) => {
      if (id === undefined) {
        return;
      }
      setIsLoading(true);
      try {
        const updateData = {
          id,
          ...data,
        };
        await httpClient.patch(`${ROOT_URL}/api/v1/banks`, updateData);
        setIsLoading(false);
        return true;
      } catch (error) {
        const message = getErrorMessage(error);
        if (openNotification) {
          openNotification({
            key: 'edit_failure',
            message: `Error editing bank #${id}`,
            description: message || 'Something went wrong',
            type: 'error',
          });
        }
        setIsLoading(false);
        return false;
      }
    },
    [id, openNotification],
  );

  return { update, isLoading };
};
